<template>
  <div class="game-controls">
    <div class="game-controls__inner">
      <ClientOnly>
        <BaseSwitcher
          v-if="!isLoggedIn"
          id="game-switcher"
          prevent
          data-id="demo-real-money-switcher-click"
          @click.native="onRealGame"
        >
          <template #left>
            <b>{{ $t("gamePage.demo") }}</b>
          </template>
          <template #right>
            <b>{{ $t("gamePage.realMoney") }}</b>
          </template>
        </BaseSwitcher>
      </ClientOnly>
      <div class="game-controls__side">
        <UiText
          font="body-caption"
          bold
          color="neutral-300"
          class="game-controls__side-mr"
          :text="$t('gamePage.view')"
        />
        <UiBtn
          :class="{ 'active': !isInFullScreenMode }"
          icon="controls/minimize"
          color="transparent"
          size-small
          @click="exitFullScreen"
        />
        <UiBtn
          :class="{ 'active': isInFullScreenMode }"
          icon="controls/maximize"
          color="transparent"
          size-small
          @click="requestFullScreen"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseSwitcher from '~/components/Base/Switcher'
import { exitFullScreen, requestFullScreen } from '~/util/browser'

export default {
  name: 'GameControls',
  components: { BaseSwitcher },
  data() {
    return {
      isInFullScreenMode: false,
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.handleFullScreenChange)
    document.addEventListener('mozfullscreenchange', this.handleFullScreenChange)
    document.addEventListener('webkitfullscreenchange', this.handleFullScreenChange)
    document.addEventListener('MSFullscreenChange', this.handleFullScreenChange)
  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.handleFullScreenChange)
    document.removeEventListener('mozfullscreenchange', this.handleFullScreenChange)
    document.removeEventListener('webkitfullscreenchange', this.handleFullScreenChange)
    document.removeEventListener('MSFullscreenChange', this.handleFullScreenChange)
  },
  methods: {
    handleFullScreenChange() {
      const isFullScreen = document.fullscreenElement
        || document.mozFullScreenElement
        || document.webkitFullscreenElement
        || document.msFullscreenElement

      this.isInFullScreenMode = Boolean(isFullScreen)
      this.$emit('full-screen', this.isInFullScreenMode)
    },
    onRealGame() {
      this.$newModal.openAuthOrRegister()
    },
    requestFullScreen() {
      if (this.isInFullScreenMode) return
      requestFullScreen()
    },
    exitFullScreen() {
      if (!this.isInFullScreenMode) return
      exitFullScreen()
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
